import React from 'react'
import ReportsNavMenu from './ReportsNavMenu'

export default function IndustryReports() {
  return (
    <>
      <ReportsNavMenu />
    </>
  )
}
